angular.module('bmsApp.crm.prospect').controller('ProspectIndexCtrl', function ($state,
																				$scope,
																				$timeout,
																				$q,
																				$cookies,
																				ngTableParams,
																				ProspectStageSvc,
																				ProspectSvc) {

	$scope.valueSlider = {
		floor: 0,
		ceil: 10000,
		format: function (value) {
			return '£' + value;
		}
	};
	$scope.weightingSlider = {
		floor: 0,
		ceil: 100,
		format: function (value) {
			return value + '%';
		}
	};

	$scope.loading = true;
	$scope.updatingActive = true;
	$scope.updatingLost = true;

	var defaultProspectParams = function () {
		return {
			page: 1, // show first page
			count: $scope.config.table.params.count, // count per page
			sorting: {
				id: 'asc'     // initial sorting
			},
			filter: {
				stage: [],
				value: {
					min: 0,
					max: 10000
				},
				weighting: {
					min: 0,
					max: 100
				},
				search: ''
			}
		};
	};

	var defaultProspectParamsActive = function () {
		var params = defaultProspectParams();
		params.filter.notStatus = ['Lost'];
		return params;
	};

	var defaultProspectParamsLost = function () {
		var params = defaultProspectParams();
		params.filter.status = ['Lost'];
		return params;
	};

	var initialProspectParams = function () {
		if (angular.isDefined($cookies.prospectIndexParams)) {
			return angular.extend({}, defaultProspectParams(), JSON.parse($cookies.prospectIndexParams));
		}
		else {
			return angular.extend({}, defaultProspectParams());
		}
	};

	var params = initialProspectParams();
	var paramsActive = initialProspectParams();
	paramsActive.filter.notStatus = ['Lost'];
	var paramsLost = initialProspectParams();
	paramsLost.filter.status = ['Lost'];

	// copy the filters to a workable state
	$scope.prospectFilters = angular.copy(params.filter);

	var promises = [
		ProspectStageSvc.options()
	];
	$q.all(promises)
		.then(function (responses) {
			$scope.prospectStageOptions = responses[0].data.options;
			$scope.loading = false;
		});

	// ACTIVE prospects
	$scope.tableParamsActive = new ngTableParams(paramsActive, {
		total: 0, // length of data
		counts: $scope.config.table.settings.counts, // available page counts
		getData: function ($defer, params) {
			$scope.updatingActive = true;
			ProspectSvc.index(params.$params)
				.then(function (response) {
					params.total(response.data.prospect_filtered_count);
					$defer.resolve(response.data.prospect_collection);
					$scope.$emit('prospectIndexActiveUpdated', {
						prospect_collection: response.data.prospect_collection,
						prospect_total_count: response.data.prospect_total_count,
						prospect_filtered_count: response.data.prospect_filtered_count
					});
					$scope.activeProspectTotal = response.data.prospect_total_count;
					$scope.activeProspectFiltered = response.data.prospect_filtered_count;
					$scope.updatingActive = false;
				});
		}
	});

	// LOST prospects
	$scope.tableParamsLost = new ngTableParams(paramsLost, {
		total: 0, // length of data
		counts: $scope.config.table.settings.counts, // available page counts
		getData: function ($defer, params) {
			$scope.updatingLost = true;
			ProspectSvc.index(params.$params)
				.then(function (response) {
					params.total(response.data.prospect_filtered_count);
					$defer.resolve(response.data.prospect_collection);
					$scope.$emit('prospectIndexLostUpdated', {
						prospect_collection: response.data.prospect_collection,
						prospect_total_count: response.data.prospect_total_count,
						prospect_filtered_count: response.data.prospect_filtered_count
					});
					$scope.lostProspectTotal = response.data.prospect_total_count;
					$scope.lostProspectFiltered = response.data.prospect_filtered_count;
					$scope.updatingLost = false;
				});
		}
	});

	// Store the table params whenever anything changes
	$scope.$watch('tableParamsActive.$params', function (value) {
		if (angular.isObject(value)) {
			var copy = angular.copy(value);
			delete copy.filter.status;
			delete copy.filter.notStatus;
			$cookies.prospectIndexParams = JSON.stringify(copy);
		}
	}, true);

	// update text search without having to click apply
	$scope.filterChanged = function () {
		$scope.tableParamsActive.$params.filter.search = $scope.prospectFilters.search;
		$scope.tableParamsLost.$params.filter.search = $scope.prospectFilters.search;
	};

	// other filters
	$scope.filterApply = function () {
		angular.extend($scope.tableParamsActive.$params.filter, angular.copy($scope.prospectFilters));
		angular.extend($scope.tableParamsLost.$params.filter, angular.copy($scope.prospectFilters));
	};

	$scope.filterReset = function () {
		angular.extend($scope.tableParamsActive.$params, defaultProspectParamsActive());
		angular.extend($scope.tableParamsLost.$params, defaultProspectParamsLost());
		angular.extend($scope.prospectFilters, defaultProspectParams().filter);
	};

	$scope.rowClicked = function (prospect) {
		$state.go('main.crm.prospect.index.view', {
			prospectId: prospect.id
		});
	};

	$scope.filterToggled = function (open) {
		if (open) {
			$timeout(function () {
				$scope.$broadcast('rzSliderForceRender');
			}, 50);
		}
	};

	$scope.tabActive = function () {
		$scope.prospectData.tab = 'active';
	};

	$scope.tabLost = function () {
		$scope.prospectData.tab = 'lost';
	};

	$scope.$on('prospectIndexActiveExport', function () {
		ProspectSvc.export($scope.tableParamsActive.$params);
	});

	$scope.$on('prospectIndexLostExport', function () {
		ProspectSvc.export($scope.tableParamsLost.$params);
	});

});
